export enum TransactionReviewStatus {
  pending = 1,
  approved = 2,
  amend = 3,
  rejected = 4,
  problematic = 5,
  reviewed = 6,
  pendingApproval = 7,
}
